const FooterVariant2 = ({ theme, font, editableData = {}, renderEditable }) => {
  const getText = (key, defaultValue) =>
    typeof editableData[key] === "string" ? editableData[key] : editableData[key]?.text || defaultValue;

  return (
    <footer
      className="py-10 px-6 text-center"
      style={{ backgroundColor: theme.footerBackground, color: theme.footerTextColor, fontFamily: font.mainText }}
    >
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: theme.footerHeadingColor }}>
          {renderEditable ? renderEditable("heading", getText("heading", "Stay in the loop")) : getText("heading", "Stay in the loop")}
        </h2>
        <p className="mb-6">
          {renderEditable
            ? renderEditable("description", getText("description", "Subscribe to our newsletter for the latest updates and resources."))
            : getText("description", "Subscribe to our newsletter for the latest updates and resources.")}
        </p>

        <div className="flex justify-center max-w-md mx-auto">
          <input
            type="email"
            placeholder={getText("emailPlaceholder", "Enter your email")}
            className="px-4 py-2 rounded-l w-full focus:outline-none"
            style={{
              backgroundColor: theme.inputBackground,
              color: theme.inputTextColor,
            }}
          />
          <button
            className="px-4 py-2 rounded-r font-medium"
            style={{
              backgroundColor: theme.primaryColor,
              color: theme.buttonTextColor,
            }}
          >
            {renderEditable ? renderEditable("subscribeButton", getText("subscribeButton", "Subscribe")) : getText("subscribeButton", "Subscribe")}
          </button>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mt-8 text-sm">
          <button className="hover:underline">{renderEditable ? renderEditable("link1", getText("link1", "Privacy")) : getText("link1", "Privacy")}</button>
          <button className="hover:underline">{renderEditable ? renderEditable("link2", getText("link2", "Terms")) : getText("link2", "Terms")}</button>
          <button className="hover:underline">{renderEditable ? renderEditable("link3", getText("link3", "Support")) : getText("link3", "Support")}</button>
          <button className="hover:underline">{renderEditable ? renderEditable("link4", getText("link4", "Contact")) : getText("link4", "Contact")}</button>
        </div>

        <p className="mt-6 text-xs">
          {renderEditable
            ? renderEditable("copyright", getText("copyright", "© 2025 Your Company. All rights reserved."))
            : getText("copyright", "© 2025 Your Company. All rights reserved.")}
        </p>
      </div>
    </footer>
  );
};

export default FooterVariant2;
